// ═══════════════════════════════════════════════════════════════════════
// 7FCC MILITARY CAMPAIGN PAGE ("/military") — SINGLE SOURCE OF CONTENT
// Fully ISOLATED from src/data/content.js ("/ready"): editing this file
// never changes /ready and editing /ready never changes /military.
// Shared visual components are reused; every content block is a full copy.
// ═══════════════════════════════════════════════════════════════════════

export const BRAND = {
  name: "7 Figure Closing Club",
  short: "7FCC",
};

export const HERO = {
  headlineLines: [
    "How People In The Military",
    "Are Earning An Extra $5K\u2060–\u2060$10K",
    "A Month Remotely From",
    "Anywhere In The World",
  ],
  subhead:
    "Learn the skill businesses already pay for, practice it with real coaching, and see if 7FCC is the right fit for you.",
};

export const VSL = {
  headline: "Get Access To This Opportunity!",
  videoLabel: "[VSL VIDEO PLACEHOLDER]",
  // ── VSL VIDEO SOURCE (single field — swap the URL, nothing else) ──
  videoSrc: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac6c4b822bc27f58fc67985.mp4",
};

export const PROOF = {
  headline: "Real Students. Real Progress.",
  support:
    "A few examples of what happens when students put the training into practice.",
  items: [
    {
      src: "/proof/proof-01.png",
      alt: "Facebook post from Joseph Ortega congratulating Salvador on closing a $10K deal",
    },
    {
      src: "/proof/proof-02.png",
      alt: "Message from Betza Rojas: 10K paid in full — 'too easy'",
    },
    {
      src: "/proof/proof-03.png",
      alt: "Team chat showing a $5K paid-in-full close and a $5,000 succeeded payment confirmation",
    },
    {
      src: "/proof/proof-04.png",
      alt: "Daily revenue board showing $41,000 in total with top setters and closers",
    },
    {
      src: "/proof/proof-05.png",
      alt: "Facebook post celebrating Mark's first $100+ win and Sarah for setting the appointment",
    },
    {
      src: "/proof/proof-06.png",
      alt: "Team chat celebrating the top closer of the week",
    },
    {
      src: "/proof/proof-07.png",
      alt: "Facebook post from Elijah Allah — collected $13,500 cash in a day as a closer",
    },
    {
      src: "/proof/proof-08.png",
      alt: "Team chat celebrating a $3,325 payment made within five days",
    },
    {
      src: "/proof/proof-featured.png",
      alt: "Facebook post announcing Brittany's Elite Closer Certification after generating over $200K in cash collected",
    },
  ],
};

// ── Testimonial video library ─────────────────────────────────────────
// Keys are stable handles. Edit src/caption freely; add new videos as new
// keys. Place them on the page via the slot arrays below (keys in order).
export const VIDEO_TESTIMONIALS_CAPTION =
  "Don't take our word for it. Hear it from the students putting in the reps.";

export const TESTIMONIAL_VIDEOS = {
  // Original four
  romy: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac42ce77d735ea2a14a21ba.mp4",
    alt: "Student video testimonial 1",
    caption: "",
  },
  ryleigh: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac42ce7b12649a51231507c.mp4",
    alt: "Student video testimonial 2",
    caption: "",
  },
  jackson: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac44a69195f9172ed99417b.mp4",
    alt: "Student video testimonial 3",
    caption: "",
  },
  hayne: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac44a69195f9172ed994186.mp4",
    alt: "Student video testimonial 4",
    caption: "",
  },
  // Military campaign additions
  navy5day: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac67bc4bbad531ac8132a1b.mp4",
    alt: "Student video testimonial 5",
    caption: "",
    aspect: "9 / 16",
  },
  oscar: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac67bc4195f9172edd24108.mp4",
    alt: "Student video testimonial 6",
    caption: "",
    aspect: "16 / 9",
  },
  jacob: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac67bc4195f9172edd240fd.mp4",
    alt: "Student video testimonial 7",
    caption: "",
    aspect: "16 / 9",
  },
  navy30day: {
    src: "https://assets.cdn.filesafe.space/CscG0b1eU7e07D3fczKL/media/6ac67bc4d66e1673fe0c18f8.mp4",
    alt: "John Pierre video testimonial",
    caption: "",
    aspect: "9 / 16",
  },
};

// Placement slots (arrays of TESTIMONIAL_VIDEOS keys, in display order).
// Strongest pair right after the survey; everything else in Wins.
// John Pierre (navy30day) is the spotlight under the survey (SPOTLIGHT).
// Wins: jacob + oscar (16:9) on top, five portraits below.
export const WINS_TOP = ["jacob", "oscar"];
export const WINS_VIDEOS = ["navy5day", "romy", "hayne", "jackson", "ryleigh"];

// Spotlight under the survey: headline left, video right.
export const SPOTLIGHT = {
  videoKey: "navy30day",
  name: "John Pierre",
  headline: "John Pierre Made $10K In His First Month",
  support: "Using this opportunity while serving in the Navy.",
};

// Survey section copy (the mock quiz questions are gone; the live GHL
// survey owns the flow). To swap surveys later, change ONLY the src/id here.
export const QUIZ = {
  headline: "Talk To A Live Expert In The Next 20 Minutes",
};

// Gate on the VSL: the video stays locked until the visitor completes the
// /military GHL survey (same survey + workflows as the card below it).
export const OPTIN = {
  title: "Get Access To This Opportunity!",
  support: "Answer a few quick questions to unlock the video.",
  storageKey: "7fcc_military_optin",
  source: "7FCC Military Funnel",
  // Where the visitor goes when the video ends (the book-a-call page).
  endRedirect: "/apply",
};

export const SURVEY = {
  src: "https://api.leadconnectorhq.com/widget/survey/LQANFVQxaZnxqQt2RHDH",
  iframeId: "LQANFVQxaZnxqQt2RHDH",
  title: "7FCC Qualification Survey",
};

export const FAQ = {
  heading: "Questions before you apply?",
  items: [
    {
      q: "Do I need sales experience?",
      a: "No. Some students start from zero and others come in with experience. The training is designed to build the fundamentals and improve through practice.",
    },
    {
      q: "Is this just an online course?",
      a: "No. 7FCC combines training with coaching, roleplay, repetition and community so students can actually practice the skill.",
    },
    {
      q: "Can I do this remotely?",
      a: "Yes. The training and community are built for remote participation.",
    },
    {
      q: "What happens after I apply?",
      a: "We'll review where you're at and what you're trying to accomplish. If it makes sense to continue, you'll receive the next step to speak with the team.",
    },
  ],
};

export const CTA = {
  label: "Talk To A Live Expert Now",
  targetId: "qualify",
  note: "60-second application. No sales experience required.",
};

export const FOOTER = {
  links: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms", href: "#" },
    { label: "Contact", href: "#" },
  ],
  copyright: "Copyright © 7FCC",
};

// Social-proof widget demo data (temporary, same as /ready's).
export const ACTIVITY_NOTIFICATIONS = [
  { firstName: "Jessica", location: "Jacksonville, FL", action: "just booked her Success Call" },
  { firstName: "Marcus", location: "Dallas, TX", action: "just applied to 7FCC" },
  { firstName: "Ashley", location: "Phoenix, AZ", action: "just booked a call with the 7FCC team" },
  { firstName: "Chris", location: "Orlando, FL", action: "just submitted an application" },
  { firstName: "Taylor", location: "Austin, TX", action: "just booked a Success Call" },
  { firstName: "Brianna", location: "Miami, FL", action: "just submitted an application" },
  { firstName: "Jordan", location: "Atlanta, GA", action: "just booked his Success Call" },
  { firstName: "Kevin", location: "Chicago, IL", action: "just applied to 7FCC" },
  { firstName: "Samantha", location: "Denver, CO", action: "just booked a call with the 7FCC team" },
  { firstName: "Tyler", location: "Nashville, TN", action: "just booked her Success Call" },
  { firstName: "Brittany", location: "Charlotte, NC", action: "just submitted an application" },
  { firstName: "Andre", location: "Houston, TX", action: "just booked a Success Call" },
  { firstName: "Megan", location: "Portland, OR", action: "just applied to 7FCC" },
  { firstName: "Devonte", location: "Detroit, MI", action: "just booked a call with the 7FCC team" },
  { firstName: "Kayla", location: "Tampa, FL", action: "just submitted an application" },
  { firstName: "Robert", location: "Phoenix, AZ", action: "just booked his Success Call" },
  { firstName: "Jasmine", location: "Newark, NJ", action: "just applied to 7FCC" },
  { firstName: "Cody", location: "Boise, ID", action: "just submitted an application" },
  { firstName: "Alexis", location: "San Diego, CA", action: "just booked a call with the 7FCC team" },
  { firstName: "Malik", location: "Philadelphia, PA", action: "just booked her Success Call" },
  { firstName: "Heather", location: "Columbus, OH", action: "just submitted an application" },
  { firstName: "Sean", location: "Boston, MA", action: "just applied to 7FCC" },
  { firstName: "Victoria", location: "Las Vegas, NV", action: "just booked a Success Call" },
  { firstName: "Isaiah", location: "Memphis, TN", action: "just booked a call with the 7FCC team" },
  { firstName: "Rachel", location: "Minneapolis, MN", action: "just submitted an application" },
  { firstName: "Eric", location: "Salt Lake City, UT", action: "just booked his Success Call" },
  { firstName: "Lauren", location: "St. Louis, MO", action: "just applied to 7FCC" },
  { firstName: "Jamal", location: "Baltimore, MD", action: "just booked a call with the 7FCC team" },
  { firstName: "Brooke", location: "Indianapolis, IN", action: "just submitted an application" },
  { firstName: "Trevor", location: "Kansas City, MO", action: "just booked her Success Call" },
  { firstName: "Monica", location: "El Paso, TX", action: "just applied to 7FCC" },
  { firstName: "Darius", location: "Cleveland, OH", action: "just submitted an application" },
  { firstName: "Stephanie", location: "Tucson, AZ", action: "just booked a Success Call" },
  { firstName: "Blake", location: "Oklahoma City, OK", action: "just booked a call with the 7FCC team" },
  { firstName: "Amber", location: "Pittsburgh, PA", action: "just submitted an application" },
];
